// style.js (tam hali)
const styles = (theme) => ({
    /* ====== Layout ====== */
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#f9f9f9",
        width: "100%",
        padding: 0,
    },

    // Kart: masaüstünde sabit genişlikte ve ortalı
    card: {
        width: "100%",
        maxWidth: 1024,
        margin: "0 auto",
        backgroundColor: "#fff",
        padding: 40,
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,.06)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",   // <- kart içeriğini ortala
    },

    /* ====== Headings ====== */
    title: {
        fontSize: 20,
        fontWeight: 500,
        textAlign: "center",
        color: "#222",
        marginTop: 20,
        marginBottom: 10,
    },

    description: {
        fontSize: 16,
        textAlign: "center",
        color: "#555",
        marginTop: 0,
        marginBottom: 30,
    },

    /* ====== Stepper + Form ====== */
    stepper: {
        width: "100%",
        margin: "0 auto 16px",
    },

    // Her adım gövdesi
    stepBody: {
        width: "100%",
        maxWidth: "100%",          // içerik genişliği (720–900 arası ayarlanabilir)
        margin: "0 auto",       // kendi kendini ortalar
        flexDirection: "column",
        alignItems: "stretch",
        // İçeride hala dar bir Paper/Card varsa ortala ve genişlet
        "& .MuiPaper-root, & .MuiCard-root": {
            marginLeft: "auto",
            marginRight: "auto",
            width: "100% !important",
            maxWidth: "100%",
        },
        // Doğrudan çocuklar da ortalansın
        "& > *": {
            marginLeft: "auto",
            marginRight: "auto",
            width: "100%",
        },
    },



    // Adım 0: FormControl & RadioGroup tam genişlik
    formControl: {
        width: "100%",
        display: "block",
    },

    radioGroup: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 18,
        padding: "10px 0",
        alignItems: "flex-start",
        "& .MuiFormControlLabel-root": { marginLeft: 0 },
    },

    textField: {
        width: "100%",
        "& label": { fontSize: 14 },
        "& input": { fontSize: 16, padding: 14 },
    },

    /* ====== Buttons & Misc ====== */
    buttonContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        maxWidth: "100%",
        margin: "20px auto 0",
    },

    button: {
        padding: "14px 24px",
        fontSize: 18,
        fontWeight: 700,
        textTransform: "none",
        borderRadius: 8,
        "&.MuiButton-contained": {
            backgroundColor: "#007bff",
            color: "#fff",
            "&:hover": { backgroundColor: "#0056b3" },
        },
        "&.MuiButton-outlined": {
            borderColor: "#007bff",
            color: "#007bff",
            "&:hover": { borderColor: "#0056b3", color: "#0056b3" },
        },
    },

    fileUpload: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 12,
        border: "2px dashed #007bff",
        borderRadius: 8,
        cursor: "pointer",
        backgroundColor: "#f0f8ff",
        "&:hover": { backgroundColor: "#e0f0ff" },
    },

    summaryBox: {
        backgroundColor: "#f8f8f8",
        padding: 24,
        borderRadius: 8,
        border: "1px solid #ddd",
    },

    /* ====== Mobile ====== */
    [theme.breakpoints.down("sm")]: {
        card: {
            maxWidth: "100%",
            width: "100%",
            padding: 30,
            boxShadow: "none",
            borderRadius: 0,
        },
        title: { fontSize: 24 },
        textField: {
            "& input": { fontSize: 14, padding: 12 },
        },
        stepper: { maxWidth: "100%" },
        stepBody: { maxWidth: "100%" },
        formContainer: { maxWidth: "100%" },
        buttonContainer: { maxWidth: "100%" },
    },
});

export default styles;
